'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = feedUsers;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function populateFeedUser(state, action) {
  var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var feedUserKey = action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
  if (state[feedUserKey]) return Object.assign({}, state[feedUserKey], overwrite);
  return overwrite;
}

function feedUsers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.REQUEST_MINI_PROFILE:
      var requestedFeedUser = populateFeedUser(state, action, { isFetching: true, isError: false });
      var requestedFeedUserKey = action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
      return Object.assign({}, state, _defineProperty({}, requestedFeedUserKey, requestedFeedUser));
    case _actionTypes.FAIL_MINI_PROFILE:
      var failedFeedUser = populateFeedUser(state, action, { isFetching: false, isError: true });
      var failedFeedUserKey = action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
      return Object.assign({}, state, _defineProperty({}, failedFeedUserKey, failedFeedUser));
    case _actionTypes.RECEIVE_MINI_PROFILE:
      var receivedFeedUser = populateFeedUser(state, action, _extends({
        isFetching: false,
        isError: false
      }, action.payload.response.feedUser));
      var receivedFeedUserKey = action.payload.feedUserType + '-' + action.payload.feedUserRelatedId;
      return Object.assign({}, state, _defineProperty({}, receivedFeedUserKey, receivedFeedUser));
    default:
      return state;
  }
}